import { useNavigate } from 'react-router-dom'
import { StyledButton, StyledButtonProps } from './StyledButton'

type HistoryBackButtonProps = {
  url?: string
} & StyledButtonProps

export const HistoryBackButton: React.FC<HistoryBackButtonProps> = (props) => {
  const navigate = useNavigate()
  const { url, ...rest } = props

  return (
    <StyledButton
      onClick={() => {
        if (url) {
          navigate(url)
        } else {
          navigate(-1)
        }
      }}
      data-test="history-back"
      {...rest}
    >
      戻る
    </StyledButton>
  )
}
